import React, { FC } from 'react';
import { ArrowBackwardIcon, Asset, ArrowRightAltIcon } from '@clearcover/atlas';
import styles from '../Details/styles.module.css';
import {
  ActivitySummaryElement,
  RatedPremiumChange,
} from '@clearcover/core-app-types';
import {
  InfoValuePairDataType,
  isDisplayValuePair,
} from 'Shared/components/Card/CardSectionInfoPairs/InfoPair';
import {
  formatDateTimeFullWithAbbreviatedTimezone,
  formatMoney,
  isPresent,
  valueOrEmdash,
} from 'Shared/utils';

const DiffIcon: FC<{ diff: number }> = ({ diff }) =>
  diff === 0 ? (
    <></>
  ) : (
    <Asset
      className={diff > 0 ? styles.increase : styles.decrease}
      icon={ArrowBackwardIcon}
      height={16}
      width={16}
      description="arrow"
    />
  );

const formatMoneyDiff = (
  premiumChange: RatedPremiumChange
): InfoValuePairDataType => {
  const { old, new: _new, diff } = premiumChange;
  return {
    display: (
      <div className={styles.premiumDiff}>
        <DiffIcon diff={diff} />
        <span>
          {formatMoney(_new)} / {formatMoney(diff)}
        </span>{' '}
        <span className={styles.previous}>Previously: {formatMoney(old)}</span>
      </div>
    ),
    value: premiumChange.new.toString(),
  };
};
export const formatDiff = (
  oldValue: InfoValuePairDataType,
  newValue: InfoValuePairDataType
): InfoValuePairDataType => {
  const plainNewValue = isDisplayValuePair(newValue)
    ? newValue.value
    : valueOrEmdash(newValue as string);
  const plainOldValue = isDisplayValuePair(oldValue)
    ? oldValue.value
    : valueOrEmdash(oldValue as string);

  if (
    (!isPresent(plainOldValue) && !isPresent(plainNewValue)) ||
    plainOldValue === plainNewValue
  ) {
    return plainNewValue;
  }
  return {
    display: (
      <div className={styles.premiumDiff}>
        <div className={styles.orageDotContainer}>
          <span className={styles.orangeDot}></span>
        </div>
        <span className={styles.previous}>
          {isDisplayValuePair(oldValue) ? oldValue.display : oldValue}{' '}
        </span>
        <Asset
          icon={ArrowRightAltIcon}
          height={16}
          width={16}
          description="arrow"
        />
        <span>
          {isDisplayValuePair(newValue) ? newValue.display : newValue}
        </span>
      </div>
    ),
    value: plainNewValue,
  };
};
export const formatSummaryElement = (
  element: ActivitySummaryElement,
  timeZone?: string
): InfoValuePairDataType => {
  switch (element.format) {
    case 'moneyDiff':
      return formatMoneyDiff(element.value);
    case 'timestamp':
      return formatDateTimeFullWithAbbreviatedTimezone(element.value, timeZone);
    case 'money':
      return formatMoney(element.value);
    default:
      return element.value;
  }
};
